import React from 'react';
import { InternalStandardProps } from '@mui/material';
import { MegadraftEditor } from 'megadraft';
import 'megadraft/dist/css/megadraft.css';
import { EditorState } from 'draft-js';
import InputLabel from '@mui/material/InputLabel';
import { Item } from '../../../crud-graphql-containers/Utils/genericTypes';
import { useEditContextForInput } from '../../Input/useEditContextForInput';

interface Plugin {
  type: string;
  // tslint:disable-next-line
  buttonComponent: any;
  // tslint:disable-next-line
  blockComponent: any;
}

export type DraftFieldProps = {
  field: string;
  item?: Item;
  label?: string;
  plugins?: Plugin[];
  readOnly?: boolean;
  // draft does not provide a type definition (any)
  // tslint:disable-next-line
  customStyleMap?: any;
  onChange?: (field: string, value: EditorState) => void;
  sidebarRendererFn?: () => JSX.Element;
} & InternalStandardProps<React.HTMLAttributes<HTMLDivElement>>;

const DraftField: React.FC<DraftFieldProps> = ({
  className,
  field,
  item = {},
  style,
  onChange,
  label,
  sidebarRendererFn,
}: DraftFieldProps) => {
  let editorState;
  let props = {};
  // If we provide an onChange function it prevails from using context
  if (onChange) {
    editorState = item[field];
    props = {
      ...props,
      onChange: (e: EditorState) => onChange(field, e),
    };
  } else {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { fieldValue, onChange: onInputChange } = useEditContextForInput<EditorState>(field);
    editorState = fieldValue;
    props = {
      onChange: (e: EditorState) => onInputChange(e),
    };
  }

  if (!editorState) {
    return null;
  }

  return (
    <>
      <InputLabel htmlFor={label}>{label}</InputLabel>
      <MegadraftEditor
        {...props}
        className={className}
        style={style}
        editorState={editorState}
        spellCheck={true}
        sidebarRendererFn={sidebarRendererFn}
      />
    </>
  );
};

// eslint-disable-next-line import/no-default-export
export default DraftField;
